module.exports = __webpack_public_path__ + "img/m05.c4ad3692.png";